export const sleep = (wait) =>
  new Promise((resolve) => setTimeout(resolve, wait));
